import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const get = (key) => {
      const m = hash.match(new RegExp(`[#&]${key}=([^&]+)`));
      return m ? decodeURIComponent(m[1]) : null;
    };

    const token = get("token");
    const email = get("email");
    const name = get("name");
    const picture = get("picture");

    if (!email || !token) {
      navigate("/admin/login?error=auth_failed");
      return;
    }

    setAuthToken(token);
    setUser({ email, name: name || email, picture: picture || "" });
    window.history.replaceState(null, "", window.location.pathname);
    // verify against backend
    checkAuth?.();
    navigate("/admin", { replace: true });
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center text-gold">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-gold/30 border-t-gold rounded-full animate-spin mx-auto mb-4"></div>
        <div className="text-sm uppercase tracking-widest">Authenticating...</div>
      </div>
    </div>
  );
}
